import React from 'react';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import TabletIcon from '@material-ui/icons/Tablet';
import LaptopIcon from '@material-ui/icons/Laptop';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
function LayoutButtonGroup(props) {
    const [layout, setlayout] = React.useState('lg');
    const handleChange = (event, newlayout) => {
        setlayout(newlayout);
        props.onHandleChange(newlayout)
    };
    React.useEffect(()=>{
        setlayout(props.layout)
    },[])
    return (
        <div>
          <ToggleButtonGroup size="small" value={layout} exclusive onChange={handleChange} style={{marginRight:8}}>
          <ToggleButton value="xs" size="small" style={{padding: 4}}>
            <PhoneAndroidIcon fontSize="small" />
          </ToggleButton>
          <ToggleButton value="sm" size="small" style={{padding: 4}}>
            <TabletIcon fontSize="small" />
          </ToggleButton>
          <ToggleButton value="md" size="small" style={{padding: 4}}>
            <LaptopIcon fontSize="small" />
          </ToggleButton>
          <ToggleButton value="lg" size="small" style={{padding: 4}}>
            <DesktopWindowsIcon fontSize="small" />
          </ToggleButton>
        </ToggleButtonGroup>  
        </div>
    );
}

export default LayoutButtonGroup;